import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Button from "@material-ui/core/Button";
import { colorsV2 } from "../styles/colors";
import { Switch } from "@material-ui/core";

import NPSService from "../services/nps";

export default (props) => {
  const [recommend, setRecommend] = useState(0);
  const [comment, setComment] = useState("");
  const [step, setStep] = useState(1);
  const [checked, setChecked] = useState(false);

  //Server data
  const [cover, setCover] = useState(null);
  const [provider, setProvider] = useState(null);
  const [name, setName] = useState(null);
  const [webReviewEnabled, setWebReviewEnabled] = useState(false);
  const [googleReviewUrl, setGoogleReviewUrl] = useState("");
  const [yelpReviewUrl, setYelpReviewUrl] = useState("");

  const msg = "It's clients like you that help us improve each and every day!";
  const extendedMsg =
    "It's clients like you that help us improve each and every day! If you have a few more moments please consider leaving us a review on the web.";

  const handleChange = (event, value) => {
    setRecommend(value);
  };

  const submit = () => {
    NPSService()
      .submitNPSResponse(props.match.params.token, !checked, recommend, comment)
      .then((resp) => {
        //call was ok
      })
      .catch((err) => {
        //handle err
      })
      .finally(() => {
        setStep(2);
      });
  };

  useEffect(() => {
    if (props.match.params.token !== null) {
      NPSService()
        .validateNPSToken(props.match.params.token)
        .then((resp) => {
          if (resp) {
            if (resp.tokenValid && resp.userCanSubmit) {
              setCover(resp.coverUrl);
              setProvider(resp.authorName);
              setName(resp.appName);
              setWebReviewEnabled(resp.webReviewEnabled);
              setGoogleReviewUrl(resp.googleReviewUrl);
              setYelpReviewUrl(resp.yelpReviewUrl);
            } else if (!resp.tokenValid) {
              props.history.push("../nps-invalid/");
            } else {
              props.history.push("../nps-submitted/");
            }
          } else {
            props.history.push("../nps-invalid/");
          }
        })
        .catch((err) => {
          props.history.push("../nps-invalid/");
        });
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          border: "solid 1px grey",
          padding: 30,
          borderRadius: 10,
          margin: 30,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              border: "solid 2px grey",
              height: 200,
              width: 175,
              borderRadius: 7,
              backgroundImage: `url(${cover})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <p
            style={{
              textAlign: "center",
              fontSize: 16,
              color: colorsV2.main,
              margin: 0,
            }}
          >
            {name}
          </p>
          <p style={{ textAlign: "center", margin: 0, fontSize: 14 }}>
            {provider}
          </p>
        </div>
        {step === 1 && (
          <div>
            <h1
              style={{
                textAlign: "center",
                textDecoration: "underline",
                color: colorsV2.main,
              }}
            >
              Tell Us How We Did
            </h1>
            <p style={{ color: colorsV2.main }}>
              We value your feedback and will use it to make our practice and
              our care even better the next time around!
            </p>
            <p>
              How likely are you to recommend us to a friend or colleague?{" "}
              <span style={{ color: "red" }}>*</span>
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignContent: "center",
                  width: 400,
                }}
              >
                <span>Not Likely</span>
                <span>Very Likely</span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignContent: "center",
                  width: 420,
                }}
              >
                <ToggleButtonGroup
                  value={recommend}
                  exclusive
                  onChange={handleChange}
                  size="large"
                  color="primary"
                  variant="contained"
                >
                  <ToggleButton value={1}>1</ToggleButton>
                  <ToggleButton value={2}>2</ToggleButton>
                  <ToggleButton value={3}>3</ToggleButton>
                  <ToggleButton value={4}>4</ToggleButton>
                  <ToggleButton value={5}>5</ToggleButton>
                  <ToggleButton value={6}>6</ToggleButton>
                  <ToggleButton value={7}>7</ToggleButton>
                  <ToggleButton value={8}>8</ToggleButton>
                  <ToggleButton value={9}>9</ToggleButton>
                  <ToggleButton value={10}>10</ToggleButton>
                </ToggleButtonGroup>
              </div>
            </div>
            {recommend > 0 && (
              <div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {recommend > 6 && <p>What do you like the most about us?</p>}
                  {recommend <= 6 && (
                    <p>
                      How did we disappoint you and what can we do to make
                      things right?
                    </p>
                  )}
                  <TextField
                    id="comment"
                    label=""
                    variant="outlined"
                    value={comment}
                    multiline={true}
                    rows={3}
                    maxRows={7}
                    maxLength={4000}
                    onChange={(event) => setComment(event.target.value)}
                  />
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "left",
                      alignItems: "center",
                      marginBottom: 0,
                    }}
                  >
                    <p style={{ fontSize: 16 }}>
                      Include my name and email with my submission
                    </p>
                    <Switch
                      value={checked}
                      onChange={(event) => setChecked(event.target.checked)}
                    />
                  </div>
                  <p style={{ fontSize: 12, margin: 0 }}>
                    By leaving the above unchecked, your response will be sent
                    anonymously
                  </p>
                </div>
              </div>
            )}
            <div
              style={{
                marginTop: 20,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                type="primary"
                variant="contained"
                onClick={submit}
                style={{
                  backgroundColor: colorsV2.lightningYellow,
                  color: "white",
                }}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div>
            <h1 style={{ textAlign: "center", color: colorsV2.main }}>
              Thank you for the feedback!
            </h1>
            <p>{recommend > 6 ? extendedMsg : msg}</p>
            {recommend > 6 && webReviewEnabled && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {yelpReviewUrl && (
                  <Button
                    color="primary"
                    variant="outlined"
                    style={{
                      width: 300,
                      marginTop: 35,
                      marginBottom: 35,
                      backgroundColor: colorsV2.lightningYellow,
                      color: "white",
                    }}
                    onClick={() => {
                      window.open(yelpReviewUrl);
                    }}
                  >
                    Leave a YELP Review
                  </Button>
                )}
                {googleReviewUrl && (
                  <Button
                    color="primary"
                    variant="outlined"
                    style={{
                      width: 300,
                      backgroundColor: colorsV2.lightningYellow,
                      color: "white",
                    }}
                    onClick={() => {
                      window.open(googleReviewUrl);
                    }}
                  >
                    Leave a Google Review
                  </Button>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/layout/NPSSurvey.js